const model = {
  id: '',
  content: '',
  resource_id: '',
  resource_type: ''
}

export default {
  SET_RECOMMENDATIONS (state, recommendations) {
    state.recommendations = recommendations
  },
  SET_ACTIVE_RECOMMENDATION (state, recommendation) {
    state.active_recommendation = recommendation
  },
  UNSET_ACTIVE_RECOMMENDATION (state) {
    state.active_recommendation = Object.create(model)
  },
  UPDATE_FIELD (state, { field, message }) {
    state.active_recommendation[field] = message
  },
  SET_IS_SUBMITTING (state, status) {
    state.is_submitting = status
  },
  SET_IS_DELETING (state, status) {
    state.is_deleting = status
  }
}
